<div class="fake-body"> 

<header class="header-bar header-bar-client-view animated fadeIn delay-1" [style.background-color]="company.accounting_company.color">
    <div class="container">
        <div class="row">
            <div class="col-sm-7 col-md-7">
                <div class="practice-header">
                    <div class="practice-logo-name"><img src="{{company.accounting_company.logo}}" alt="{{company.accounting_company.name}}"></div>
                </div>

                <hr class="visible-xs" style="margin-top: 40px;">
            </div>
            <div class="col-sm-5 col-md-5">
                <div class="welcome-user"> 
                    <div class="welcome-user-avatar-wrapper">
                        <div class="avatar avatar-64 avatar-welcome-user">
                            <div class="avatar-inicitials" initials [name]="user.first_name + ' ' + user.last_name"></div>
                        </div>
                    </div>
                    <div class="welcome-user-name-wrapper">
                        <h2>
                            <div style="font-size: 20px;margin-top: 5px;">{{user.first_name}} {{user.last_name}}</div>
                            <div style="font-size: 1rem;opacity:.7">&#64; {{company.name}}</div>
                        </h2>
                        <!-- <a (click)="openMyAccountModal()"><i class="feather user"></i> My account</a> -->
                        <!-- <a (click)="logout()"><i class="feather log-out"></i> Logout</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<div class="widgets animated fadeInUp delay-3">
    <div class="container">
        <div class="row">
            <div class="col-md-7">
                <app-apps-widget [preview]="true"></app-apps-widget>
                <app-resources-widget [preview]="true"></app-resources-widget>
            </div>
            <div class="col-md-5">
                <div class="panel panel-default communications-widget coming-soon">
                    <div class="panel-heading">
                        Communications <span class="badge">1</span>
                        <button class="btn btn-success">Ask something</button>
                    </div>
                    <div class="panel-body">
                        <div class="label-date-wrapper">
                            <div class="label-date">Today</div>
                        </div>
                        <div class="bubble bubble-attention">
                            <div class="bubble-avatar">
                                <div class="avatar avatar-32">
                                    <div class="avatar-inicitials">CP</div>
                                </div>
                            </div>
                            <div class="bubble-content">
                                <div class="bubble-message-sender">
                                    <span class="bubble-message-sender-name">Chicago Accounting Pros</span>
                                    <span class="bubble-message-sender-time">10:30am</span>
                                </div>
                                <div class="bubble-message-text">
                                    Vivamus efficitur consectetur ante, sed condimentum mauris consectetur sollicitudin.
                                </div>
                            </div>
                            <div class="bubble-action-right">Reply</div>
                        </div>
                        <div class="label-date-wrapper">
                            <div class="label-date">Yesterday</div>
                        </div>
                        <div class="bubble">
                            <div class="bubble-message">
                                <div class="bubble-avatar">
                                    <div class="avatar avatar-32">
                                        <div class="avatar-inicitials">JM</div>
                                    </div>
                                </div>
                                <div class="bubble-content">
                                    <div class="bubble-message-sender">
                                        <span class="bubble-message-sender-name">Jane Maxwell</span>
                                        <span class="bubble-message-sender-time">2:13pm</span>
                                    </div>
                                    <div class="bubble-message-text">
                                        Pellentesque eu turpis rutrum?
                                    </div>
                                </div>
                            </div>
                            <div class="bubble-message">
                                <div class="bubble-avatar">
                                    <div class="avatar avatar-32">
                                        <div class="avatar-inicitials">CP</div>
                                    </div>
                                </div>
                                <div class="bubble-content">
                                    <div class="bubble-message-sender">
                                        <span class="bubble-message-sender-name">Chicago Accounting Pros</span>
                                        <span class="bubble-message-sender-time">3:27pm</span>
                                    </div>
                                    <div class="bubble-message-text">
                                        <a><i class="feather download"></i> filename.pdf</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div class="panel panel-default reviews-widget" *ngIf="company.show_reviews">
                    <div class="panel-heading">
                        Leave a review
                    </div>
                    <div class="panel-body">
                        <div class="row text-center">
                            <div class="col-4 col-sm-3 col-md-3" *ngIf="company.accounting_company.review_linkedin != '' && company.accounting_company.review_linkedin != null">
                                <a href="{{company.accounting_company.review_linkedin}}" target="_blank" rel="noreferrer noopener"><img src="assets/img/reviews/linkedin.png" alt="LinkedIn"></a>
                            </div>
                            <div class="col-4 col-sm-3 col-md-3" *ngIf="company.accounting_company.review_xero != '' && company.accounting_company.review_xero != null">
                                <a href="{{company.accounting_company.review_xero}}" target="_blank" rel="noreferrer noopener"><img src="assets/img/reviews/xero.png" alt="Xero"></a>
                            </div>
                            <div class="col-4 col-sm-3 col-md-3" *ngIf="company.accounting_company.review_proadvisor != '' && company.accounting_company.review_proadvisor != null">
                                <a href="{{company.accounting_company.review_proadvisor}}" target="_blank" rel="noreferrer noopener"><img src="assets/img/reviews/proadvisor.png" alt="ProAdvisor"></a>
                            </div>
                            <div class="col-4 col-sm-3 col-md-3" *ngIf="company.accounting_company.review_yelp != '' && company.accounting_company.review_yelp != null">
                                <a href="{{company.accounting_company.review_yelp}}" target="_blank" rel="noreferrer noopener"><img src="assets/img/reviews/yelp.png" alt="Yelp"></a>
                            </div>
                            <div class="col-4 col-sm-3 col-md-3" *ngIf="company.accounting_company.review_google != '' && company.accounting_company.review_google != null">
                                <a href="{{company.accounting_company.review_google}}" target="_blank" rel="noreferrer noopener"><img src="assets/img/reviews/google.png" alt="Google"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>

<footer class="clients-view-footer">
    <div class="container">
        <div class="row">
            <div class="col-sm-4">
                <div style="padding: 5px;margin-right: 5px;margin-top:5px;"><strong>{{company.accounting_company.name}}</strong></div>
            </div>
            <div class="col-sm-8 text-right">
                <div class="practice-logo-urls">
                    <a target="_blank" rel="noreferrer noopener" href="{{company.accounting_company.facebook}}"><i class="fa fa-facebook-official" aria-hidden="true"></i><span class="hidden-xs"> Facebook</span></a>
                    <a target="_blank" rel="noreferrer noopener" href="{{company.accounting_company.linkedin}}"><i class="fa fa-linkedin-square" aria-hidden="true"></i><span class="hidden-xs"> LinkedIn</span></a>
                    <a target="_blank" rel="noreferrer noopener" href="{{company.accounting_company.twitter}}"><i class="fa fa-x-twitter" aria-hidden="true"></i><span class="hidden-xs"> Twitter</span></a>
                    <a target="_blank" rel="noreferrer noopener" href="{{company.accounting_company.url}}"><i class="fa fa-external-link" aria-hidden="true"></i> Website</a>
                </div>
            </div>
        </div>
    </div>
</footer>


</div> 

